module.exports = __webpack_public_path__ + "img/ИФ-1(А)-023-m.fd894fc5.png";